import { fetchApi } from '../api/digitalVault';
import { parseFileVersions } from '../utils';
export default async (repository, props, logger) => {
    const { versions } = await fetchApi(props, `repository/${repository}/version`, {}, false, logger);
    return parseFileVersions(versions.version);
};
